export const PERK_CARD = {
  root: 'perk-card-root',
  appliedIcon: 'perk-card-applied',
  image: 'perk-card-image',
  heading: 'perk-card-heading',
  subtitle: 'perk-card-subtitle',
  scheduledPerk: 'perk-card-scheduled',
};
